import HomePageLayout from '../../components/organisms/HomePageLayout';

const Homepage = () => {
  return <HomePageLayout />;
};

export default Homepage;
